import { EditOutlined } from '@ant-design/icons';
import React from 'react';
export const columns = (onEdit) => {
    return [
        {
            title: 'Subscription Name',
            dataIndex: 'name',
        },
        {
            title: 'Free Plays',
            dataIndex: 'numberOfFreePlays',
        },
        {
            title: 'Games',
            dataIndex: 'gameRoomIds',
            render: (val: any) => {
                return val && val.length > 0 ? val.length : 'No Games';
            },
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            render: (_, record) => (
                <div className={'action-button'}>
                    <EditOutlined onClick={() => onEdit?.(record)} />
                </div>
            ),
            width: '10%',
        },
    ];
};
